import 'bootstrap/js/src/popover';
import 'bootstrap/js/src/alert';

import 'jquery-toggles/css/toggles.css';
import 'jquery-toggles/css/themes/toggles-light.css';

import 'select2';
import 'jquery-colorbox';
import 'bootstrap-3-typeahead/bootstrap3-typeahead';

import '../static/major/scss/extra.scss';
import 'shared-ui/src/global.scss';
import '../static/major/css/pretty-photo.css';
import '../static/js/colorbox/colorbox.css';
import '../static/js/autocomplete/jquery.autocomplete.css';
import '../static/js/tooltip/jquery.tooltip.css';
import '../static/js/stars/jquery.rating.css';

import '../static/major/js/valign-imgs';
import '../static/major/js/osqa-messages';
import '../static/major/js/glossary';
import '../static/major/js/generaleffects';
import '../static/js/autocomplete/jquery.autocomplete';
import './account/social_login';
import './promo/promo-box-modal';
import './match-score/match-score-lazy-load';

import {enableShowCodeButton} from "./promo/promo-code";
import {
  trackFullReviewCTA,
  trackGetDirectionsCTA,
  trackMiscActions,
  trackQuizCTAClickFrom,
  trackShopBedCTA,
  trackShopStoreCTA,
  trackTakeQuizCTA,
  trackSaveExtraCTA
} from "./analytics/cta";
import {trackLDPMetrics} from "./analytics/ldp-metrics";
import {trackSearchEvent, trackSearchSubmitEvent} from "./analytics/search";
import {initializePopovers, initializeRebatePopover, setupClosePopoverOnClickOutside} from "./popovers/popovers";
import {promoBoxTrigger} from "./react-components/promo/modals/online-promo-modal";
import {initPromoButton} from "./react-components/promo/buttons/sale";
import {ServiceWorkerSetup} from '../static/push/sw-setup';
import * as Sentry from '@sentry/browser';
import {BrowserTracing} from "@sentry/tracing";
import {setCookie} from "./utils";

const PACKAGE_VERSION = require('../package.json').version;

const REBATE_MODAL = ".rebate-popup-modal";

Sentry.init({
  dsn: SENTRY_DSN,
  environment: process.env.NODE_ENV,
  release: PACKAGE_VERSION,
  sampleRate: 0.5,
  tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.15 : 1,
  integrations: [new BrowserTracing()],
  debug: process.env.NODE_ENV !== 'production',
  autoSessionTracking: false,
  beforeSend(event, hint) {
    const error = hint.originalException;

    if (error && error.stack && error.stack.indexOf('tag/js/gpt.js') !== -1) {
      // Ignore errors from Google Optimize/Google Tag Services
      return null;
    }

    return event;
  }
});

window.ServiceWorkerSetup = ServiceWorkerSetup;
window.setCookie = setCookie;
window.enableShowCodeButton = enableShowCodeButton;
window.initializeRebatePopover = initializeRebatePopover;
window.initializePopovers = initializePopovers;
window.trackQuizCTAClickFrom = trackQuizCTAClickFrom;
window.trackSearchSubmitEvent = trackSearchSubmitEvent;
window.trackFullReviewCTA = trackFullReviewCTA;
window.trackSaveExtraCTA = trackSaveExtraCTA;

$(document).ready(() => {
  enableShowCodeButton();
  initializePopovers();
  setupClosePopoverOnClickOutside();
  promoBoxTrigger();
  trackTakeQuizCTA();
  trackShopStoreCTA();
  trackGetDirectionsCTA();
  trackShopBedCTA();
  trackMiscActions();
  trackLDPMetrics();
  trackSearchEvent();
  initPromoButton();
  trackFullReviewCTA();
  trackSaveExtraCTA();
});
